/**
 * Custom component for $2 wishlist app
 * This component send ajax request to the app proxy and add the response to iwishlistProducts container
 * ------------------------------------------------------------------------------
 * Template in snippets/my-wishlist.liquid
 *
 */

import $ from 'jquery';
import Vue from 'vue';
import handlesToTiles from '../utilities/handlesToTiles';

const emptyHeart = '<svg class="mobile-empty-wish-list-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none">' + 
                    '<defs>' +
                      '<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">' +
                        '<use xlink:href="#image0_323_713" transform="translate(0 0.0126582) scale(0.0126582)"></use>' +
                      '</pattern>' +
                      '<image id="image0_323_713" width="70" height="70" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABNCAYAAADn/DmNAAAACXBIWXMAAAsSAAALEgHS3X78AAAE/ElEQVR4nO2c/ZWjNhTFL24g7mDpYN1B6CDuIGwHTgekgymB7cDpgHTg7YDpwFPByx/IDhbvSQKBnjzje46OD0aWLj89SXwIF0SEWBVFcQCwB1BZu64ALgAuRHSNrmiepwpAadJYvUnxnohodjKGTgDOACgwXQC8ASiX1BngaQ+gBtAt8HRYVOdMgxWAdoY5KXUAqhWhtRiiPMZTD6BeHd7IYCw0O50B7CPAnVaAxkEMatgQg8cZBnsTVbcU8rsrgOOCaOtmRPk4hUJsfQ3rM9l4KriY1hdbCsP4WMM/PjaB4A6eRumNJ3EcG3lqPWVdXABdJltPq5QLulnpKzcC3MXViJ4odnV/EaBrLJEKWjQzWeVXJkKCAXrAnVbwtMcw8wYDlA5s0RiwwKzUlRsrrwSuX6Mxrbpqoa5Jo3IHxEWEsztFmpW68dHjyTkeRXqSGuthYrN/xIXteStwHoBXDGMkF52bgRt5OgqRfq93nLn0ZVYAyEXcFRtdpTCeuGBqOHhcxlnnX5FG9yaiuC48TlViT3YDXjl4dh/vUpkceTh4wDUKnmrGR32HJ2RIFnWW2UYAd9HwYzzZ0Xcew7PHm17LqGA2aXcNbND9DoOOeNQZumqs7X+JqFPwcVPLfFftiqIoAfxm7VCFR0QtgPfRV42Ok0FE1OPRDwAcdhgGaTtzl8CTT4351I66mzpru+Lg2YS1dAbwAb7LaKi3tu9jniuTimh4vnAyXTgHddb29x2mD236FE5ClBE4VtlG3jOIg/dSoF7wIsTB2yd38aTaYTqLTM77XuL1irxwVdb2+w7DPbSxvqfx8nSyg6rfYbiP9yCzcOelR9lMLjvhuvEFb6rfre3+Nub9snZU23t5Hpnlara6G7zO2sFl/sqy73d+ENFFgvdNoP1VZcPrAHOqQkS32z9jnbb3lL+KojgC+GZ9fQYez/Psu8d/vGZdANMg+sCN1eghR4npQ45O80GQdgL/VLG577cyt0xmlUeQ2gnCA2+MVlDYl2cNE7ZvRVF8xUu2E6Zj3RuNV9AzxBtMo+9NOxISRx23cqGHtW4nNFxVHzonBietmZkMX1IBFfPjq03+MybMWGY3t5BO++A2BsetyRODxlWQ1H0b7YPcCFzQatAgeKMCuRVLlfbBrgxOGuecE2VIwdzK+CtWXkitDI9duuv9XWDhLVf4Z5hAhLE9aOluaAVSWHfaBx8Jro4ZluZUVAoDaqsNYSE4aTwPfiFmboVVbIU5JMfMOisQllQshXqtDSXQv/hSzOyyFhqQ3tHK+g6MY+xeNPnFGOFm4GxPYRzgFr8UE2tIMpMdQPDnclFet2zNbAAKvST6SmkNY1kDdICro8teyWApTP39koH4GcCtBs8Ylc6dVC7jtga3KrycADrArXoyv4VxVYAOcO3qdW10ACoAU4LbDF4AwNVn4dTgNoXnAbjqaYwGuM3hpQCoBS4JvK0Awv2/LJuDSwZvbYBw/5lDsnuLyeAFAKxXABdUxlPCGwHslxw8hsvALMCpwFsaPY6oVQGnBi8AYBsILri7fyp4oQAh/6uY+i2vwhhUVVEULYA/mV3vmC4wBIZ1wRUR2a9+JVUW79sSUQ3gJ7OLA/cLGYADMoEH3AH+7cmWDTggI3gAQEQNgB/C7n8wgJu8aKilLMY8W+btozP+/6ehnyYys1JWkXcTDW9iVhgmhr9yBAcA/wGDNIvRldTpwQAAAABJRU5ErkJggg=="></image>' +
                    '</defs>' +
                    '<rect width="16" height="16" fill="url(#pattern0)"></rect>' +
                  '</svg>';
const fullHeart = '<svg class="mobile-liked-wish-list-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
                    '<defs>' +
                      '<pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">' +
                        '<use xlink:href="#image0_41_5218" transform="translate(0 0.0126582) scale(0.0126582)"></use>' +
                      '</pattern>' +
                      '<image id="image0_41_5218" width="70" height="70" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABNCAYAAADn/DmNAAAACXBIWXMAAAsSAAALEgHS3X78AAAEEElEQVR4nO2cPWsUQRjHf7ONxMrW6hTTBIRoGThQENLYxCqkE/QDHPkS0Ub8AJdarS6l5SmC5SEINgmYKlqlkaRIyGOxu5fNZl9m9m1mcvuDp0hu7+7Pf57ZmZ155pSIUBel1CZwF9hIvXQMfAEmInJY+4vMNI2Ah8By6qV94GcjmkTEOIAhMAGOANGME2AGDKt8p4amATAmbDBTTZuVvtNQ4ChqOV1xeXEMjBo0bR+4qKnpDBg3bl5CYF3T0nEEDGoYN2nAtCwTtRpWR+BOCwKTcQHsVMg2k+5ZJfbLGrZM5LRlgcmYahq32XJjJuOkyMAikW1009LWdsi4UgOL7iVdG1dooCXjCg3MEjmyaFwcU4eMy23UrBvxmQPmCdEg4qKmPPNmDgiM44JwMm4yEW87zkh036RxQwfEZYm1rSEd81uKioxDKTUDHtFThohIABAk/rlqSYxvKKXUGCLzoj+UVUl+8RwIu61Sah94YFmQb9yLzbugzzxT3gRKqSG9cVVYC4j6b48xqwGwZluFp9wKyq/pyWFJES4q3rGtxEf6zKtBb14NevNq0JtXgwD4YVuEr/SZV53zAPhuW4Wn/AuAv7ZVeMrveFVFbCvxkL34nndqVYaffIwzr9+/MENEJIgz77NVKf4RjhOJrUfbO/I+xTi99djvY+ghwH0ROUxOkl9aEuMbXyWqZZ5nHvTZp8E86+D649nLzuX4xTzrALJKzKbYvyG7GFeKfPLq8wa4WWBjO67VTedVhrpQ4OhSHGX5dGXASNI/dcwREoNEkqL1vA3gvDVJ/vA2yzggu9umaoFtdxmbMSvyJ7fbxiilJlw/kLcInIrI7aILSpfhReQFcNCYJD8QYL3sIt09jGcs1prftoh8K72qqE+n7n9DFmPlZaLtie6FCzL/Kzy+ZTxgpInql18ZvckPSgeINMbmwY2cQJ8CK7nzuRwqbXqLyGNuzggswLqpcVCjYkBElvF/BBZgS2tkzaBuucUKfhu4LSKfKr/bZHTJGYEHhOdRbY+UpmH0Ywy1pyo3aA5Y27jGzIsMdOFAcWfGNWqeJwZqPz3oRKV5XhHRTyN9wL1TRQcSzhAao/HiRglHry3ClnaFxo2DlipDHTOwFeOgxbJaRwxszThouSbZsoGtGgcdFHRbMrB146CjaviODdzrwjjo8ChBRwbuSrjn0g1NThoNJtJtlHM09uRgbZKsg1JqAPwClhr6yF0Red3QZ2lj5QSQhAuPTSxnCZaMg4rL8I19eb0MFMKFzOrrcTWxat5chHlFqnXjwJGDe9HUQndP5BQHjANHMi9GKTUFnhRcUmmXqy2cyLwYEXkK7Oa8/AeHjAPHMi8m+mnyd1yuCXbyuGWKU5kXIyLvuXwa6exxy5T/aQ4SKzKxc0gAAAAASUVORK5CYII="></image>' +
                    '</defs>' +
                    '<rect width="16" height="16" fill="url(#pattern1)"></rect>' +
                  '</svg>';      


const productsPerPage = 48;

$('.iwishProducts').change(function(changes, observer) {
  console.log('element ' + this.id, changes, observer);
});

$(document).on('click', '.iwishBtn.remove', function(e) {
  e.preventDefault();
  if ($('.iwishProducts .product-item').length === 0) {
    document.dispatchEvent(new CustomEvent('setEmpty', { detail: true }));
  }

  const $target = $(this);
  $target.html(emptyHeart).addClass('add').removeClass('remove');

  return iwish_remove($(this), $(this).attr('data-variant'), true);
});

$(document).on('click', '.iwishBtn.add', function(e) {
  e.preventDefault();

  const $target = $(this);
  $target.html(fullHeart).removeClass('add').addClass('remove');

  return iwish_add($(this), $(this).attr('data-variant'), true);
});


Vue.component('my-wishlist', {
  props: ['customer'],
  data() {
    return {
      isLoading: true,
      isLoadingMore: false,
      observer: null,
      productIds: [],
      handles: [], 
      variantsRetrieved: [],
      isLoggedIn: false,
      isEmpty: localStorage.getItem('iWishCnt') 
        ? (localStorage.getItem('iWishCnt') <= 0) 
        : false,
      shareIconsHTML: '<div class="skeleton" style="height: 2.5rem;"></div>',
    };
  },
  

  methods: {

    async syncWishlist() {
      if (this.customer) {
        this.handles = await window.fetchHandles({ customerId: this.customer });
      } else {
        const wishlistData = JSON.parse(localStorage.getItem('iWishlistmain') || '{}');
        if (!wishlistData || Object.keys(wishlistData).length === 0) {
          this.isEmpty = true;
          return;
        }
        const filteredWishlistData = Object.fromEntries(
          Object.entries(wishlistData).filter(([productId, variants]) =>
            Array.isArray(variants) && variants.length > 0
          )
        );
        if (Object.keys(filteredWishlistData).length === 0) {
          console.log("No valid wishlist items found.");
          this.isEmpty = true;
          return;
        } else {
          this.isEmpty = false;
        }
        this.productIds = Object.keys(filteredWishlistData)
          .filter(id => Array.isArray(filteredWishlistData[id]) || filteredWishlistData[id] === true)
          .map(id => Number(id));
        if (this.productIds.length === 0) {
          this.isEmpty = true;
          return;
        }
        this.handles = await window.fetchHandles({ productIds: this.productIds });
      }
      if (!this.handles || !this.handles.length) {
        this.isEmpty = true;
      } else {
        console.log("Received handles:", this.handles);
        await this.loadProducts();
      }
    },
  
    async loadProducts(loadMore = false) {
      if (this.donePaginating || this.isLoadingMore) {
        console.warn(this.isLoadingMore ? 'calm down' : 'all done');
        return;
      }
  
      this.isLoadingMore = true;
      this.page++;
  
      const tilesContainer = document.createElement('div');
      const responseHTML = document.createElement('div');
  
      const tiles = await handlesToTiles(this.handles);
      tilesContainer.innerHTML = tiles.join('');
      responseHTML.innerHTML = tiles.join('');
  
      tilesContainer.innerHTML = this.appendRemoveButton(tilesContainer)
        .map(obj => obj.outerHTML)
        .join('');
  
      const productTiles = tilesContainer.querySelectorAll('.product-item');
  
      if (productTiles.length === 0) {
        console.log("No products found for the given handles.");
        this.isEmpty = true;
        return;
      }
  
      productTiles.forEach(tile => {
        this.$refs.productsWrapper.appendChild(tile);
      });
  
      console.log(`Loaded ${productTiles.length} products into the wishlist.`);
      this.isEmpty = false;
      this.isLoading = false;
  
      ///we need some logic for this as it was scraped//
      if (productTiles.length < 1) {
        this.isEmpty = true;
        this.shareIconsHTML = '';
      } else {
        this.isEmpty = false;
        this.shareIconsHTML = responseHTML.querySelector('.iwishShareContainer') 
          ? responseHTML.querySelector('.iwishShareContainer').innerHTML 
          : '';
      }
      
    
    },
  
    getCount: async function() {
      const wishlistData = JSON.parse(localStorage.getItem('iWishlistmain') || '{}');
      
      const productIds = Object.keys(wishlistData).filter(id => 
        Array.isArray(wishlistData[id]) && wishlistData[id].length > 0
      );

      const tileCount = productIds.length;
    
      this.isEmpty = tileCount === 0;
      localStorage.setItem('iWishCnt', tileCount);
      document.querySelector('.iWishCount').innerText = tileCount;
    },
  
    appendRemoveButton(tiles) {
      let productTiles = Array.from(tiles.querySelectorAll('[data-evg-item-id]')); 
      let uniqueTiles = new Set();
      
      productTiles = productTiles.filter(tile => {
        let itemId = tile.getAttribute('data-evg-item-id');
        if (!uniqueTiles.has(itemId)) {
          uniqueTiles.add(itemId);
          return true;
        } else {
          const wishlist = JSON.parse(localStorage.getItem('iWishlistmain')) || {};
          const variantId = wishlist[itemId];
  
          for (let i = 1; i < variantId.length; i++) {
            $(tile).attr('data-product', itemId);
            iwish_remove($(tile), variantId[i], true);
          }
        }
        return false;
      });
    
      let productIds = productTiles.map(t => t.getAttribute('data-evg-item-id'));  
      let wishlistItems = JSON.parse(localStorage.getItem('iWishlistmain')) || {};
    
      const normalizedWishlistItems = {};
      for (const [variantId, variants] of Object.entries(wishlistItems)) {
        const productId = variantId.split('-')[0];
        normalizedWishlistItems[productId] = variants;
      }
    
      let matchedItems = [];
      for (let i = 0; i < productIds.length; i++) {
        let productId = productIds[i];
        if (normalizedWishlistItems.hasOwnProperty(productId)) {
          let wishlistItemId = normalizedWishlistItems[productId][0];
          matchedItems.push({ productId, wishlistItemId });
        }
      }
       
      matchedItems.forEach(item => {
        let appended = false;
        let productTile = productTiles.find(tile => tile.getAttribute('data-evg-item-id') === item.productId);
        if (productTile && !appended) {
          let priceContainer = productTile.querySelector('.product-item__price');
    
          if (priceContainer) {
            const isLiked = normalizedWishlistItems[item.productId];
            const heartIcon = isLiked ? fullHeart : emptyHeart;
    
            priceContainer.innerHTML += `
              <a class="iwishBtn ${isLiked ? 'remove' : 'add'}" href="#" data-variant="${item.wishlistItemId}" 
                  data-product="${item.productId}" title="${isLiked ? 'Remove from wishlist' : 'Add to wishlist'}">
                ${heartIcon}
              </a>`;
          } else {
            console.warn("Missing .product-item__price in product tile:", productTile);
          }
          appended = true;
        }
      });
    
      productTiles.forEach(tile => {
        const itemId = tile.getAttribute('data-evg-item-id');
        const priceContainer = tile.querySelector('.product-item__price');
    
        if (priceContainer && !normalizedWishlistItems[itemId]) {
          priceContainer.innerHTML += `
            <a class="iwishBtn add" href="#" data-product="${itemId}" title="Add to wishlist">
              ${emptyHeart}
            </a>`;
        } else if (!priceContainer) {
          console.warn("⚠️ Missing .product-item__price for product ID:", itemId);
        }
      });
      return productTiles;
    }
  },    
  
  async mounted() {

    if (this.customer) {
      this.isLoggedIn = true;
    }

    await this.syncWishlist();
  
    let options = {
      root: null,
      rootMargin: '500px',
      threshold: 1
    };
    let callback = (entries, observer) => {
      if (entries.some(e => e.isIntersecting)) {
        console.log("You're close!");
        this.loadProducts(true);
      }
    };
  
    let target = document.getElementById('loadMoreMarker');
    this.observer = new IntersectionObserver(callback, options);
    this.observer.observe(target);
  
    this.getCount();
  }
  
});